<template>
  <ScaleBox :height="2000" :width="1679" :isScale="isbig">
    <div class="desk-wrapper order-detail console-wrapper flex-one" style="display: flex">
      <el-row type="flex" :gutter="10" class="flex-one">
        <el-col :span="12" class="flex-vertic">
          <div class="common-box flex-one">
            <div class="o-title border">呼叫实时情况</div>
            <div class="console-item">
              <div class="item">
                <div>今日呼叫</div>
                <div class="num num-family">{{ todayCallJsonData.curDayCnt }}</div>
              </div>
              <div class="item">
                <div>呼叫完成</div>
                <div class="num num-family">{{ todayCallJsonData.callPercentageComplete }}</div>
              </div>
              <div class="item">
                <div>呼叫平均完成时间</div>
                <div class="num num-family">{{ todayCallJsonData.averageCompletionTime }}</div>
              </div>
              <!-- <div class="item">
                <div>计划完成效</div>
                <div class="num num-family">{{ todayCallJsonData.planPercentageComplete }}</div>
              </div> -->
            </div>

            <div class="map-echart">
              <mapchart ref="mapchart" @watchChild="loadMapSumHtmlWay"></mapchart>
            </div>
            <div class="console-return">
              <el-button @click="returnMap">返回</el-button>
            </div>
            <div class="console-data" id="console-data-id">
            </div>
            <div class="c9">
              <!-- 注：实际展现效果是地图上显示具体每个乡镇、街道、社区的数据（红色、蓝色、绿色）地图上默认显示青少年总量和呼叫量，弹窗显示的数据是0、区域名称1青少年总量2呼叫量,3颜色标注，4未成年（5-18岁）：人数，（虚拟数据），涉案：人数；成年（18-25岁）：人数，（虚拟数据），
              涉案：人数。不同身份登入显示所在区域的地图和数据。 -->
            </div>
          </div>
          <div class="common-box mt10 flex-one" style="display: flex;flex-direction: column;height: 200px !important;">
            <div class="o-title border">五类青少年分布</div>
            <div class="line-echart-box">
              <fiveChart ref="fiveChart"></fiveChart>
            </div>
          </div>
          <!-- <div class="common-box mt10 flex-one"
               style="display: flex; flex-direction: column">
            <div class="o-title border">参与机构穿透图</div>
            <div class="line-echart-box">
              <testChart></testChart>
            </div>
          </div> -->
          <div class="common-box mt10 flex-one" style="display: flex; flex-direction: column">
            <div class="o-title border">年呼叫量趋势</div>
            <div class="line-echart-box">
              <linechart ref="linechart"></linechart>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="flex-vertic">
          <el-row type="flex" :gutter="10" class="flex-one">
            <el-col :span="24" class="flex-vertic">
              <div class="common-box flex-one flex-vertic">
                <div class="o-title border">往年预青数据</div>
                <linechart2 ref="linechart2"></linechart2>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="10" class="flex-one">
            <el-col :span="24" class="flex-vertic">
              <div class="common-box flex-one flex-vertic">
                <div class="o-title border">历年预青数据</div>
                <linechart3 ref="linechart3"></linechart3>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="10" class="flex-one">
            <el-col :span="12" class="flex-vertic">
              <!-- <div class="common-box index-container flex-one">
            <div class="o-title border">五类青少年涉案分布</div>
            <fiveChart></fiveChart> -->
              <!--  <div class="rank-container">
                        <div class="item" v-for="item in 7" :key="item">
                            <div class="name"><span class="ovh"><span class="dot" :class="{'act':item<3}">{{item}}</span>晋安区人民检察院{{item}}</span></div>
                            <div class="num num-family">323,234</div>
                        </div>
                    </div> -->
              <!-- </div> -->
              <!-- <div
            class="common-box mt10 flex-one df"
            style="flex-direction: column"
          >
            <div class="o-title border">参与机构穿透图</div>
            <div class="flex-one">
              <assistanceChart></assistanceChart>
            </div>
          </div> -->
              <!-- <div class="common-box flex-one flex-vertic">
                                <div class="o-title border">热门呼叫词</div>
                                <div class="hot-label-wrapper flex-one">
                                    <scatterchart></scatterchart>
                                </div>
                            </div> -->

              <div class="common-box flex-one mt10 flex-vertic" v-if="adolescentData.criminalCnt != undefined">
                <div class="o-title border">青少年信息</div>
                <div class="rescue_flex">
                  <div class="rescue_one">
                    <div class="rescue_font">有纹身数量</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.tattooCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">在校处分量</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.disciplinaryCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">常出没于娱乐场所</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.entertainmentCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">作息时间不规律</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.workTimeCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有夜不归宿行为</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.nightOutCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有观看淫秽行为</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.videoCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有打架行为</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.fightCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">喜欢网络游戏</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.gameCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有手淫行为</div>
                    <div class="fs24 c0 num-family">{{ adolescentData.workTimeCnt }}</div>
                  </div>
                  <!-- <div class="hot-label-wrapper flex-one">
                  <scatterchart></scatterchart>
                </div> -->
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="flex-vertic">
              <!-- <div class="common-box index-container flex-one">
            <div class="o-title border">五类青少年涉案分布</div>
            <fiveChart></fiveChart> -->
              <!--  <div class="rank-container">
                        <div class="item" v-for="item in 7" :key="item">
                            <div class="name"><span class="ovh"><span class="dot" :class="{'act':item<3}">{{item}}</span>晋安区人民检察院{{item}}</span></div>
                            <div class="num num-family">323,234</div>
                        </div>
                    </div> -->
              <!-- </div> -->
              <!-- <div
            class="common-box mt10 flex-one df"
            style="flex-direction: column"
          >
            <div class="o-title border">参与机构穿透图</div>
            <div class="flex-one">
              <assistanceChart></assistanceChart>
            </div>
          </div> -->
              <!-- <div class="common-box flex-one flex-vertic">
                                <div class="o-title border">热门呼叫词</div>
                                <div class="hot-label-wrapper flex-one">
                                    <scatterchart></scatterchart>
                                </div>
                            </div> -->
              <div class="common-box flex-one mt10 flex-vertic" v-if="salvageData.materialsSalvageCnt != undefined">
                <div class="o-title border">救助数据</div>
                <div class="rescue_flex">
                  <div class="rescue_one">
                    <div class="rescue_font">救助件总数</div>
                    <div class="fs24 c0 num-family">{{ salvageData.materialsSalvageCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">救助在办件</div>
                    <div class="fs24 c0 num-family">{{ salvageData.salvageCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">救助完成件</div>
                    <div class="fs24 c0 num-family">{{ salvageData.salvageDoneCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">救助资金总额</div>
                    <div class="fs24 c0 num-family">{{ salvageData.salvageDoneCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">救助总人数</div>
                    <div class="fs24 c0 num-family">{{ salvageData.salvagePersonCnt }}</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">实物救助的人数</div>
                    <div class="fs24 c0 num-family">{{ salvageData.salvageUndoCnt }}</div>
                  </div>
                </div>
                <!-- <div class="hot-label-wrapper flex-one">
                  <scatterchart></scatterchart>
                </div> -->
              </div>
              <!-- <div class="common-box flex-one mt10 flex-vertic">
                <div class="o-title border">青少年信息</div>
                <div class="rescue_flex">
                  <div class="rescue_one">
                    <div class="rescue_font">有纹身数量</div>
                    <div class="fs24 c0 num-family">11</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">曾有过过激行为</div>
                    <div class="fs24 c0 num-family">24</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">常出没于娱乐场所</div>
                    <div class="fs24 c0 num-family">14</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">作息时间不规律</div>
                    <div class="fs24 c0 num-family">12</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有夜不归宿行为</div>
                    <div class="fs24 c0 num-family">5</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有观看淫秽行为</div>
                    <div class="fs24 c0 num-family">10</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有打架行为</div>
                    <div class="fs24 c0 num-family">11</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">喜欢网络游戏</div>
                    <div class="fs24 c0 num-family">50</div>
                  </div>
                  <div class="rescue_one">
                    <div class="rescue_font">有手淫行为</div>
                    <div class="fs24 c0 num-family">8</div>
                  </div>
                </div>
              </div> -->
            </el-col>
            <!-- <el-col :span="12"
                    class="flex-vertic">
              <div class="common-box flex-one">
                <div class="o-title border">工单情况预测</div>
                <div class="c9">评估</div>
                <div class="c9 fs18 mt10">有望达到预期</div>
                <div class="line-chart-box2">
                  <linechart1></linechart1>
                </div>
              </div>
              <div class="common-box mt10 flex-one">
                <div class="o-title border">流转效率</div>
                <div class="dashboard-chart">
                  <dashboard></dashboard>
                </div>
              </div>
              <div class="common-box mt10 flex-one">
                <div class="o-title border">资源剩余</div>
                <div class="wave-chart-box">
                  <wavechart></wavechart>
                </div>
              </div>
            </el-col> -->
          </el-row>
          <el-row type="flex" class="flex-one">
            <div class="common-box flex-one">
              <div class="o-title border">呼叫计划类型占比</div>
              <div class="console-item" >
                <div class="item ml20 mr20" style="height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[0]"
                  :proportion="breatheTyleData.proportion[0]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[0]}}</div>
                </div>
                <div class="item ml20 mr20" style="height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[1]"
                  :proportion="breatheTyleData.proportion[1]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[1]}}</div>
                </div>
                <div class="item ml20 mr20" style="height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[2]"
                  :proportion="breatheTyleData.proportion[2]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[2]}}</div>
                </div>
                
              </div>
              <div class="console-item" >
                <div class="item ml20 mr20" style="margin-top: 20px; height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[3]"
                  :proportion="breatheTyleData.proportion[3]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[3]}}</div>
                </div>
                <div class="item ml20 mr20" style="margin-top: 20px; height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[4]"
                  :proportion="breatheTyleData.proportion[4]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[4]}}</div>
                </div>
                <div class="item ml20 mr20" style="margin-top: 20px; height: 120px">
                  <consoleCirclechart :chartData="breatheTyleData.data[5]"
                  :proportion="breatheTyleData.proportion[5]"></consoleCirclechart>
                  <div class="tac c9">{{breatheTyleData.nameData[5]}}</div>
                </div>
              </div>
              <!-- <div class="flex_center_nihao">
                <div class="common-box item flex static-item">
                  <div class="item-circle">
                    <el-avatar :size="52"
                               shape="square"
                               fit="contain"
                               :src="`/img/bg/icon9.jpg`"></el-avatar>
                  </div>
                  <div class="item ml20 flex-one">
                    <div class="fs24 c0 num-family">100</div>
                    <div class="c9">救助总数量</div>
                  </div>
                </div>
                <div class="common-box item flex static-item">
                  <div class="item-circle">
                    <el-avatar :size="52"
                               shape="square"
                               fit="contain"
                               :src="`/img/bg/icon13.jpg`"></el-avatar>
                  </div>
                  <div class="item ml20 flex-one">
                    <div class="fs24 c0 num-family">8</div>
                    <div class="c9">帮教总数量</div>
                  </div>
                </div>
                <div class="common-box item flex static-item">
                  <div class="item-circle">
                    <el-avatar :size="52"
                               shape="square"
                               fit="contain"
                               :src="`/img/bg/icon15.jpg`"></el-avatar>
                  </div>
                  <div class="item ml20 flex-one">
                    <div class="fs24 c0 num-family">12</div>
                    <div class="c9">帮扶总数量</div>
                  </div>
                </div>
              </div> -->
            </div>
            <!-- <el-row type="flex" :gutter="10" class="flex-one">
              <div class="common-box flex-one">
                <div class="o-title border">工作信息</div>
              </div>
            </el-row> -->
          </el-row>
          <!-- <el-row type="flex"
                  class="flex-one mar mt10">
            <div class="common-box flex-one">
              <div class="o-title border">工作信息</div>
              <testChart2></testChart2>
            </div>
          </el-row> -->
        </el-col>
      </el-row>
    </div>
  </ScaleBox>
</template>
<script>
import ScaleBox from "@/components/scale-box/index.vue";
import radder from "@/components/chart/radder.vue";
import dashboard from "@/components/chart/dashboard.vue";
import mapchart from "@/components/chart/mapchart.vue";
import linechart from "@/components/chart/linechart.vue";
import linechart1 from "@/components/chart/linechart1.vue";
import linechart2 from "@/components/chart/linechart2.vue";
import linechart3 from "@/components/chart/linechart3.vue";
import consoleCirclechart from "@/components/chart/consoleCirclechart.vue";
import wavechart from "@/components/chart/wavechart.vue";
import scatterchart from "@/components/chart/scatterchart.vue";
import fiveChart from "@/components/chart/fiveChart.vue";
import assistanceChart from "@/components/chart/assistanceChart.vue";
import testChart from "@/components/chart/testChart.vue";
import testChart2 from "@/components/chart/testChart2.vue";
import { mapGetters } from "vuex";
import { todayCallData, callVolumeTrendData, formerYearsYouthData, overYearsYouthData, adolescentData, salvageData, breatheTyleData } from '@/api/console/index.js';
import { statregionDetail } from '@/api/echart/common.js';
import { adolescentKindData } from '@/api/wel/index.js';
export default {
  components: {
    radder,
    dashboard,
    mapchart,
    linechart,
    linechart1,
    linechart2,
    linechart3,
    consoleCirclechart,
    wavechart,
    scatterchart,
    fiveChart,
    assistanceChart,
    ScaleBox,
    testChart,
    testChart2,
  },
  computed: {
    ...mapGetters(["isbig"]),
  },
  // computed: {
  // 计算属性的 getter
  // getRandom: function() {
  //     return function(min = 0, max = 100) {
  //         return Math.floor(Math.random() * (max - min) + min)
  //     }
  // },
  // getRandomColor: function() {
  //     let arr = []
  //     return function(min = 0, max = 100) {
  //         return Math.floor(Math.random() * (max - min) + min)
  //     }
  // }
  // },
  data() {
    return {
      adolescentData: {},
      salvageData: {},
      breatheTyleData: {
          sum:0,
          nameData:["心理援助", "教育支持", "社区矫正", "督促监护令", "社会救助", "最低保障"],
          data:[],
          proportion:[]
      },
      radio4: "最新更新",
      status: "first",
      tableData: [{
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      {
        date: "2016-05-02",
        name: "D234231029431",
        name1: "精神慰藉-0",
        address: "xxxx机构",
        status: "进行中",
      },
      ],
      todayCallJsonData: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 更新-呼叫实时情况
      this.todayCallData()
      //监控台-呼叫量趋势
      this.loadcallVolumeTrendDataWay()
      //监控台-往年预青数据
      this.loadFormerYearsYouthDataWay()
      //监控台-历年预青数据
      this.loadOverYearsYouthDataWay()
      //监控台-五类青少年分布
      this.loadAdolescentKindDataWay()
      //监控台-青少年信息
      this.laodAdolescentDataWay();
      //监控台-救助数据
      this.loadSalvageDataWay();
      //监控台-呼叫类型占比
      this.loadBreatheTyleDataWay();
    });
  },
  methods: {
    // 更新-呼叫实时情况
    todayCallData() {
      todayCallData().then((res) => {
        console.log("呼叫实时情况", res.data.data)
        this.todayCallJsonData = res.data.data;
        if (res.data.data.curYearDoneCnt == 0) {
          this.todayCallJsonData.callPercentageComplete = "100%"
          this.todayCallJsonData.averageCompletionTime = 0 + "天/单";
          return;
        }
        this.todayCallJsonData.callPercentageComplete = this.todayCallJsonData.curYearDoneCnt / this.todayCallJsonData.curYearCalledCnt * 100;
        this.todayCallJsonData.callPercentageComplete = this.todayCallJsonData.callPercentageComplete.toFixed(2) + "%"
        this.todayCallJsonData.averageCompletionTime = parseInt(this.todayCallJsonData.curYearDoneDays) / this.todayCallJsonData.curYearDoneCnt + "天/单";
        
      })
      // 加载地图数据
      statregionDetail().then((res) => {
        // console.log("地图",res.data.data[0])
        this.$refs.mapchart.initChart(res.data.data[0], true);
        this.loadMapSumHtmlWay(res.data.data[0]);
      })
    },
    // 添加显示当前地图地区总数据
    loadMapSumHtmlWay(data) {
      var htmlStr = '<div style="height: auto;max-height: 340px; width:fit-conten;overflow-y: auto;color:#000;line-height:1;font-size:14px">'
      htmlStr += '<div style="text-align:center;padding:15px 0;font-size:16px;font-weight:bold;">' + data.name + '</div>'
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;padding:12px 16px;font-size:14px;border-bottom:1px solid #DCDCDC"><div>青少年总数：</div><div class="mapClassShow">' + data.amount + '</div></div>'
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;padding:12px 16px;font-size:14px;border-bottom:1px solid #DCDCDC"><div>重点关注：</div><div class="mapClassShow">' + data.refAmount + '</div></div>'
      htmlStr += '<div style="padding:5px 16px">'
      // htmlStr += '<div style="padding-bottom:10px;border-bottom:1px dotted #DCDCDC;color:#25282C;"><div style="font-size:14px;color:#25282C;margin:10px 0 15px;">颜色标注</div>'

      // htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;"><div><span style="display:inline-block;width: 10px;height: 10px;background: #FF2323;border-radius:50%;margin-right:5px"></span>10</div><div><span style="display:inline-block;width: 10px;height: 10px;background: #127AFF;border-radius:50%;margin-right:5px"></span>10</div><div><span style="display:inline-block;width: 10px;height: 10px;background: #3BD413;border-radius:50%;margin-right:5px"></span>10</div></div></div>'


      htmlStr += '<div style="padding-bottom:10px;border-bottom:1px dotted #DCDCDC;color:#25282C;"><div style="font-size:14px;color:#25282C;margin:10px 0 15px;">年龄段</div>'

      // 年龄段
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">未成年(5-18)</div><div class="mapClassShow">' + data.underage + '人</div></div>'
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">涉案人数(5-18)</div><div class="mapClassShow">' + data.refUnderage + '人</div></div>'
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">成年(18-25)</div><div class="mapClassShow">' + data.adult + '人</div></div>'
      htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">涉案人数(18-25)</div><div class="mapClassShow">' + data.refAdult + '人</div></div>'

      htmlStr += '</div>'
      htmlStr += '</div></div>'
      document.getElementById("console-data-id").innerHTML = htmlStr;
    },
    //监控台-呼叫量趋势
    loadcallVolumeTrendDataWay() {
      let date = new Date();
      let Year = date.getFullYear();
      callVolumeTrendData({
        year: Year
      }).then((res) => {
        let callVolumeTrendJson = {
          xAxisData: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          seriesList: [
            {
              name: '完成数',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
            },
            {
              name: '新增数',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,],
            }
          ]
        }
        for (var key in res.data.data) {
          callVolumeTrendJson.seriesList[0].data[res.data.data[key].month - 1] = res.data.data[key].doneCnt;
          callVolumeTrendJson.seriesList[1].data[res.data.data[key].month - 1] = res.data.data[key].calledCnt;
        }
        this.$refs.linechart.setOptions(callVolumeTrendJson);
      })
    },
    //监控台-往年预青数据
    loadFormerYearsYouthDataWay() {
      formerYearsYouthData({}).then((res) => {
        this.$refs.linechart2.setOptions(res.data.data);
      })
    },
    //监控台-历年预青数据
    loadOverYearsYouthDataWay() {
      overYearsYouthData({}).then((res) => {
        this.$refs.linechart3.setOptions(res.data.data);
      })
    },
    //监控台-五类青少年分布
    loadAdolescentKindDataWay() {
      adolescentKindData({}).then((res) => {
        this.$refs.fiveChart.setOptions(this.adolescentKindDataShift(res.data.data));
      })
    },
    //五类青少年分布-转换
    adolescentKindDataShift(data) {
      let temp = {}
      let dataTypeList = []
      data.map((item) => {
        let cur = temp[item.regionCode]
        dataTypeList[item.dataType - 1] = item.dataTypeName;
        if (cur) {
          cur.data[item.dataType - 1] = item.cnt
        } else {
          cur = {
            name: item.regionName,
            code: item.regionCode,
            data: []
          }
          cur.data[item.dataType - 1] = item.cnt
          temp[item.regionCode] = cur
        }

      })
      let seriesList = {
        temp: temp,
        dataTypeList: dataTypeList
      };
      return seriesList;
    },
    //监控台-青少年信息
    laodAdolescentDataWay() {
      adolescentData({}).then((res) => {
        console.log("青少年信息", res.data.data);
        this.adolescentData = res.data.data;
      })
    },
    //监控台-救助数据
    loadSalvageDataWay() {
      salvageData({}).then((res) => {
        console.log("救助数据", res.data.data);
        this.salvageData = res.data.data;
      })
    },
    //监控台-呼叫类型占比
    loadBreatheTyleDataWay() {
      let date = new Date();
      let Year = date.getFullYear();
      breatheTyleData({
        year: Year
      }).then((res) => {
        for (let nameKey in this.breatheTyleData.nameData) {
          this.breatheTyleData.data.push(0);
          for (let key in res.data.data.planWorkType) {
            if (res.data.data.planWorkType[key].dataTypeName == this.breatheTyleData.nameData[nameKey]) {
              this.breatheTyleData.data[nameKey] = res.data.data.planWorkType[key].cnt;
              this.breatheTyleData.sum += res.data.data.planWorkType[key].cnt;
            }
          }
        }
        for(let key in this.breatheTyleData.data){
          this.breatheTyleData.proportion.push(0);
          if(this.breatheTyleData.data[key]!=0){
            this.breatheTyleData.proportion[key] =this.breatheTyleData.data[key]/this.breatheTyleData.sum*100;
            this.breatheTyleData.proportion[key] = this.breatheTyleData.proportion[key].toFixed(2);
          }
        }
        console.log("呼叫类型占比", this.breatheTyleData);
      })
    },
    returnMap() {
      this.$refs.mapchart.returnMap();
    }
  }

};

</script>
<style lang="scss" scoped>
@import "@/styles/index.scss";
@import "@/styles/moudles/desk.scss";
@import "@/styles/moudles/order.scss";
</style>
<style lang="scss" scoped="scoped">
.console-wrapper {
  .console-item {
    display: flex;

    .item {
      flex: 1;
      color: #999;

      .num {
        margin-top: 10px;
        font-size: 30px;
        color: #333;
      }
    }
  }

  .map-echart {
    height: 700px;
  }

  .console-return {
    position: absolute;
    top: 160px;
  }

  .console-data {
    position: absolute;
    top: 530px;
    right: 52%;
    border-radius: 15px;
    border-style: solid;
    border-width: thin;
    border-color: #999;
  }

  .mapClassShow {
    margin-left: 20px;
  }

  .line-echart-box {
    height: 250px;
  }

  .line-chart-box2 {
    height: 130px;
  }

  .dashboard-chart {
    height: 250px;
  }

  .wave-chart-box {
    height: 250px;
  }

  .hot-label-wrapper {
    position: relative;
    // height: 200px;
  }
}

.large-screen {
  .console-wrapper {
    .console-item .item {
      color: #aabeff;

      .num {
        color: #4ae8c8;
      }
    }
  }

  .c9 {
    color: #aabeff;
  }
}

.flex_center_nihao {
  width: 100%;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.rescue_flex {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;

  .rescue_one {
    width: 33.33%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
  }

  .rescue_font {
    font-size: 14px;
    color: #999;
    margin-bottom: 10px;
  }
}
</style>
